import { render, staticRenderFns } from "./SolicitudRenderer.vue?vue&type=template&id=e9832a60"
import script from "./SolicitudRenderer.vue?vue&type=script&lang=js"
export * from "./SolicitudRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports